import type { SVGProps } from "react";

const SvgMonetaLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 222 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="a"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={27}
      height={30}
    >
      <path
        d="M13.105 12.672 0 0v30l13.044-12.614 2.47-2.383h-.003l7.353-7.113v14.223L17.92 17.33l-2.412 2.324L26.21 30V0L13.107 12.672zm-9.76 9.438V7.887l7.352 7.11z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#a)">
      <path
        d="m-15 14.997 28.105-28.104L41.21 14.997 13.105 43.103z"
        fill="url(#b)"
      />
    </g>
    <path
      d="M52.94 23.171h3.323V6.145l-9.32 12.383-9.32-12.383V23.17h3.32v-7.48l6 8.139 5.998-8.138zm19.87-8.184c0 2.905-2.328 5.258-5.206 5.258S62.4 17.89 62.4 14.987s2.33-5.259 5.203-5.259 5.206 2.351 5.206 5.26m3.495 0c0-4.723-3.896-8.556-8.701-8.556s-8.698 3.831-8.698 8.556 3.898 8.554 8.698 8.554 8.7-3.832 8.7-8.554m5.496-1.93L94.71 23.83V6.805h-3.323v10.116L78.478 6.145V23.17h3.323V13.057m16.195 10.114h12.593v-2.996h-9.175v-3.727h8.783v-2.92h-8.783V9.86h9.175V6.805H97.996zM127.034 9.86l1.778-3.055H112.47V9.86h4.928v13.31h3.418V9.86zm8.361 7.497h-5.37l2.676-4.77zm3.297 5.812h3.774l-9.741-17.026-9.737 17.026h3.766l1.759-3.134h8.409zm22.99-4.945c0 1.14-.918 2.058-2.435 2.058h-5.013v-4.117h5.013c1.517 0 2.435.918 2.435 2.058m-.466-6.662c0 1.005-.816 1.84-2.217 1.84h-4.764V9.73h4.764c1.403 0 2.217.822 2.217 1.832m1.428 2.862c1.127-.597 1.93-1.749 1.93-3.26 0-2.492-1.942-4.359-5.04-4.359h-8.715v16.368h9.022c3.114 0 5.337-2.217 5.337-4.954 0-1.921-1-3.228-2.535-3.793m15.134 2.931H172.4l2.684-4.772zm3.3 5.814h3.781l-9.754-17.026-9.741 17.026h3.772l1.758-3.133h8.416zm8.789-10.11 12.901 10.769V6.803h-3.316v10.11L186.537 6.146V23.17h3.328V13.06zm24.339.32 7.003-6.578h-4.63l-7.235 6.797V6.803h-3.413v16.368h3.413v-5.239l2.396-2.233 5.713 7.472h4.235z"
      fill="#140757"
    />
    <defs>
      <linearGradient
        id="b"
        x1={-1.019}
        y1={28.852}
        x2={27.041}
        y2={0.792}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#140757" />
        <stop offset={0.25} stopColor="#140757" />
        <stop offset={0.29} stopColor="#270852" />
        <stop offset={0.43} stopColor="#6C0F42" />
        <stop offset={0.55} stopColor="#A31435" />
        <stop offset={0.66} stopColor="#CB182B" />
        <stop offset={0.75} stopColor="#E41B26" />
        <stop offset={0.8} stopColor="#ED1C24" />
        <stop offset={1} stopColor="#ED1C24" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgMonetaLogo;
